import React from 'react'
import { useTranslation } from 'react-i18next'
import { Crown } from 'lucide-react'

const BattleRoyaleBanner = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={onClick}
      className="hidden w-full rounded-2xl border border-amber-300/30 bg-gradient-to-r from-sky-500/15 via-amber-500/15 to-emerald-500/15 px-4 py-3 text-left transition-colors hover:border-amber-200/60"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-amber-100">
            <Crown className="h-3.5 w-3.5" />
            {t('eventOlympus.title', { defaultValue: 'Штурм Олимпа' })}
          </div>
        </div>
        <span className="shrink-0 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-xs font-semibold text-white/90">
          {t('royale.eventPromo.link', { defaultValue: 'Подробнее' })}
        </span>
      </div>
    </button>
  )
}

export default BattleRoyaleBanner
